module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10231.f3f1d1c9.jpg";